import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: sessionStorage.authenticated || false,
        user: {employee_id: null, employee_name: null},
        admin: sessionStorage.admin || false,
        userName: '',    
        userRecord: null,       
        overlay: false,
        dialog: false,
        loginErrors: '',
        resetPassword: false,
        resetPasswordShow: false,
        newPassword: '',
        displayPasswordChanged: false,        
        step: 1,
        employeeId: sessionStorage.employeeId || null,
        employeeSignedIn: '',
        employeeInitials: '',
        employeePost: '',
        validUserName: false,
        expand: true,
        appToken: sessionStorage.appToken || null              
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },     

        getUserRecord(state){
            return state.userRecord
        },

        getOverlay(state){
            return state.overlay
        },       

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },

        getResetPassword(state){
            return state.resetPassword
        },

        getNewPassword(state){
            return state.newPassword
        },

        getDisplayPasswordChanged(state){
            return state.displayPasswordChanged
        },        

        getStep(state){
            return state.step
        },
        
        getEmployeeId(state){
            return state.employeeId
        },

        getEmployeeSignedIn(state){
            return state.employeeSignedIn
        },

        getEmployeeInitials(state){
            return state.employeeInitials
        },
        
        getValidUserName(state){
            return state.validUserName
        },

        getUserName(state){
            return state.userName
        },

        getResetPasswordShow(state){
            return state.resetPasswordShow
        },
        getExpand(state){
            return state.expand
        },

        getAdmin (state) {
            return state.admin
        },

        getEmployeePost (state) {
            return state.employeePost
        },

        getAppToken(state){
            return state.appToken
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setUserId (state, value){
            state.user.student_id = value;
        },

        setUserRecord (state, value){
            state.userRecord = value
        },

        setOverlay (state, value){
            state.overlay = value
        },
        
        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },

        setResetPassword(state, value){
            state.resetPassword = value
        },

        setNewPassword(state, value){
            state.newPassword = value
        },

        setDisplayPasswordChanged(state, value){
            state.displayPasswordChanged = value
        },        

        setStep(state, value){
            state.step = value
        },

        setEmployeeId(state, value){
            state.employeeId = value
        },

        setEmployeeSignedIn(state, value){
            state.employeeSignedIn = value
        },

        setEmployeeInitials(state, value){
            state.employeeInitials = value
        },

        setValidUserName(state, value){
            state.validUserName = value
        },

        setUserName(state, value){
            state.userName = value
        },

        setExpand(state, value){
            state.expand = value
        },

        setAdmin (state, value) {
            state.admin = value
        },

        setEmployeePost (state, value) {
            state.employeePost = value
        },

        setAppToken(state, value){
            state.appToken = value
        }
    },

    actions: {
        async adminSignIn({ commit, dispatch }, credentials){
            commit('setOverlay', true);
            try {
                await axios.get('/sanctum/csrf-cookie');
                const { data} = await axios.post('/api/admin-login', credentials);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
                

                sessionStorage.appToken = data.token;
                sessionStorage.authenticated = data.name;
                sessionStorage.admin = data.name;

                commit('setAppToken', data.token);
                commit('setAdmin', true);
                commit('setLoginErrors', '')
                commit('setAuthenticated', true);
                commit('setUser', credentials);                
            } catch (error) {
                dispatch('serverError', error)
            }
            commit('setOverlay', false);             
              
        },

        async employeeSignIn({ commit, dispatch }, credentials){
            commit('setOverlay', true);
            try {
                await axios.get('/sanctum/csrf-cookie');
                const  { data } = await axios.post('/api/employee-login', credentials);
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
               
                sessionStorage.appToken = data.token;
                sessionStorage.authenticated = data;
                sessionStorage.employeeId = data.employee_id;
                
                commit('setResetPassword', data.password_reset);
                commit('setAppToken', data.token);
                commit('setAuthenticated', true);
                commit('setEmployeeId', data.employee_id);
                commit('setLoginErrors', "");                
            } catch (error) {
                dispatch('serverError', error);
                commit('setOverlay', false);
            }            
            
        },

        async employee({ getters, commit }){
            let url = '/api/employee/' + getters.getEmployeeId;
            const { data } = await axios.get(url);
            let name = '';
            let initials = '';
            let employeePostId = '';
            if(data.length > 0){
                const [{ first_name: firstName, last_name: lastName, post_id: postId } ] = data;
                name = firstName + ' ' + lastName;
                initials = firstName[0] + lastName[0];
                employeePostId = postId;
            }            
            commit('setEmployeeSignedIn', name);
            commit('setEmployeeInitials', initials);
            commit('setEmployeePost', employeePostId);            
        },        

        async user({ getters }){           
            console.log("getting user information...");
            let url = '/api/user-employee/' + getters.getUserName;            
            return axios.get(url);           
        },

        async changePassword({ getters }){            
            let url = '/api/employee-change-password';
            return await axios.post(url, {
                "name" : getters.getUserName,
                "password" : getters.getNewPassword,
            })            
        },        

        async signOut({ commit }){
            try {
                const { status } = await axios.post('/api/logout');
                console.log(status);                
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);                
            }
            commit('setAuthenticated', false);                       
            sessionStorage.clear(); 
        },        
        
       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },      

       async changeResetPassword({ commit, getters }, resetPassword){
            commit('setOverlay', true);
            await axios.post('/api/change-reset-password',{
                "student_id" : getters.getUserId,
                "reset_password" : resetPassword,
            });
            commit('setResetPassword', resetPassword);
            commit('setDisplayPasswordChanged', true);
            commit('setOverlay', false);
       },

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       },

       serverError({ commit }, err ){
            console.log(err.response)
            //var hasErrors = Object.prototype.hasOwnProperty.call(err.response, 'errors');                                              
            if( err.response){
                commit('setLoginErrors', err.response.data.errors.message[0]);
            }
            else{
                commit('setLoginErrors', err.response.statusText);
            }                    
            commit('setAuthenticated', false);
            commit('setOverlay', false);
       }
    }
}